import Logo from "../../images/logo.png";
import { ButtonApp, Loading } from "../../components";
import { useLOGIN } from "../../APIs/useMyAPI";

const Login = () => {
  const { handleChange, loading, error, handleSubmit } = useLOGIN({});
  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleSubmit("admin/login", "/");
  };

  return (
    <div className="fixed w-full h-full bg-white top-0 left-0 z-50 flex items-center justify-center text-center">
      {loading ? <Loading /> : ""}
      <div className="w-1/2 max-lg:w-[90%] flex flex-col justify-center space-y-6 border border-Brown p-10 rounded-2xl">
        <div className="flex justify-center">
          <img src={Logo} alt="" className="w-[300px] mx-auto" />
        </div>
        <div className="flex w-full mx-3">
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            className="block max-md:w-full mx-auto w-[100%] border-b border-b-Brown py-3 pr-5 font-semibold outline-none px-5"
          />
        </div>
        <div className="flex w-full mx-3">
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            className="block max-md:w-full mx-auto w-[100%] border-b border-b-Brown py-3 pr-5 font-semibold outline-none px-5"
          />
        </div>
        <div className="text-red-500 font-semibold ">{error}</div>
        <div onClick={handleFormSubmit} className="w-fit mx-auto">
          <ButtonApp>
            <span className="px-12">ارسال</span>
          </ButtonApp>
        </div>
      </div>
    </div>
  );
};

export default Login;
